<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>NSDA Decision Report</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      background-color: #f9f9f9;
    }

    .container {
      width: 90%;
      max-width: 900px;
      margin: 20px auto;
      background-color: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .header {
      text-align: center;
      margin-bottom: 20px;
    }

    .header h1, .header h2, .header h3 {
      margin: 5px;
    }

    .header-logos {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    .header-logos img {
      height: 60px;
    }

    .info p {
      margin: 6px 0;
      font-size: 14px;
    }

    .decision-note {
      margin: 20px 0;
      font-weight: bold;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      margin-bottom: 20px;
    }

    table th, table td {
      border: 1px solid #000;
      padding: 6px 8px;
      vertical-align: middle;
    }

    table th {
      background-color: #f0f0f0;
    }

    .content {
      margin-top: 20px;
      line-height: 1.6;
    }

    .content p {
      font-size: 16px;
      color: #333;
    }

    .footer {
      margin-top: 40px;
      font-size: 14px;
      color: #7f8c8d;
    }

    .footer strong {
      color: #34495e;
    }

    /* Responsive Styles */
    @media (max-width: 768px) {
      .header-logos {
        flex-direction: column;
        align-items: center;
      }

      .header-logos img {
        margin: 10px 0;
      }

      table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
      }

      .content p, .info p, .footer {
        font-size: 15px;
      }

      .container {
        padding: 15px;
      }
    }
    .title-wrapper {
      text-align: center;
      margin-bottom: 20px;
    }

    .title-wrapper h1 {
      margin: 0 auto;
      display: inline-block;
    }
  </style>
</head>
<body>
<div class="container">
  <div class="title-wrapper">
    <h1>Certificate Verification</h1>
  </div>
  <div class="header">
    <div class="header-logos">
      <img src="assets/images/gov-modify.png" alt="Govt Logo">
      <div>
        <h4>Government of the People's Republic of Bangladesh</h4>
        <h3>Prime Minister’s Office</h3>
        <h3>National Skills Development Authority (NSDA)</h3>
      </div>
      <img src="assets/images/Group 98.png" alt="NSDA Logo">
    </div>
  </div>

  <div class="info">
    <p><strong>Application ID:</strong> {{reportData[0]?.applicationId}}</p>
    <p><strong>Name of STP:</strong> {{reportData[0]?.stpName}}</p>
    <p><strong>Address:</strong> {{reportData[0]?.address}}</p>
    <p><strong>Date of decision issued:</strong> {{formatDate(reportData[0]?.decisionIssueDate)}}</p>
  </div>

  <div class="decision-note">
    NSDA has made the following decision(s) regarding your STP Registration/Course Accreditation/Assessment Center Accreditation Application(s):
  </div>

  <table>
    <thead>
    <tr>
      <th>Application for</th>
      <th>Type of Application</th>
      <th>Decision for Course Accreditation</th>
      <th>Validity: From - To</th>
      <th>Decision for Assessment Center</th>
      <th>Validity: From - To</th>
    </tr>
    </thead>
    <tbody id="report-table-body">
    <!-- Table rows will be inserted dynamically here -->
    </tbody>
  </table>

  <div class="content">
    <p>Please comply with the applicable conditions as mentioned in the respective guidelines. NSDA may take necessary action and revoke the approvals in case of non-compliance.</p>
  </div>

  <div class="footer">
    <p>Regards,</p>
    <p><strong>NSDA</strong></p>
  </div>
</div>
</body>
</html>
